export default __webpack_public_path__ + "static/media/certificate_problem_solving.08d29e9f.WebP";